<template>
    <div>
        <div class="content">
            <div class="hw-content" v-loading="loading">
                <el-collapse v-model="activeNames">
                    <el-collapse-item title="基础信息" name="1">
                        <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="项目ID">
                                <div class="rows">{{ result.Credit_Control_ID }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目成立日期">
                                <div class="rows">{{ result.Credit_Control_ApplicationTime }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="客户名称">{{ result.Credit_Control_CustomerName }}</el-descriptions-item>
                            <el-descriptions-item label="创建时间">{{ result.Credit_Control_AddTime }}</el-descriptions-item>
                            <el-descriptions-item label="项目类型">{{ result.Credit_Control_TypeName }}</el-descriptions-item>
                            <el-descriptions-item label="状态">
                                <div style="display: flex; align-items: center">
                                    <span>{{ result.Credit_Control_StateName }}</span>
                                    <template v-if="result.StateChange == 'true'">
                                        <span style="margin: 0 6px">变更：</span>
                                        <el-select v-model="result.Credit_Control_State" placeholder="请选择" class="el-select-medium" value-key="ID" filterable>
                                            <template>
                                                <el-option v-for="item in result.SelectState" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                                            </template>
                                        </el-select>
                                        <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditControlState()">更改</el-button>
                                    </template>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="分支机构">{{ result.Credit_Control_OfficeName }}</el-descriptions-item>
                            <el-descriptions-item label="经办人">
                                <div style="display: flex; align-items: center">
                                    {{ result.Credit_Control_AgentName }}
                                    <template v-if="result.AgentChange == 'true'">
                                        <span style="margin: 0 6px">变更：</span>
                                        <el-select v-model="result.Credit_Control_AgentID" placeholder="请选择" class="el-select-medium" value-key="ID" filterable>
                                            <template>
                                                <el-option v-for="item in Control_Agentopt" :key="item.ID" :label="item.ShowName" :value="item.ID"></el-option>
                                            </template>
                                        </el-select>
                                        <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditControlAgent()">更改</el-button>
                                    </template>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目金额">{{ result.Credit_Control_ProjectMoney | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="原件存档部门">{{ result.Credit_Control_Enclosure }}</el-descriptions-item>
                            <el-descriptions-item label="创建人">{{ result.Credit_Control_AddUserName }}</el-descriptions-item>
                            <el-descriptions-item label="管辖法院">{{ result.Credit_Control_Court }}</el-descriptions-item>
                            <el-descriptions-item label="发函日期">{{ result.Credit_Control_LetterTime }}</el-descriptions-item>
                            <el-descriptions-item label="承办律所">
                                <div style="display: flex; align-items: center" v-if="result.TimeChange == 'true'">
                                    <el-select v-model="result.Credit_Control_LawFirmID" placeholder="请选择" class="el-select-medium" value-key="ID" filterable>
                                        <template>
                                            <el-option v-for="item in result.CreditLawFirms" :key="item.Credit_LawFirm_ID" :label="item.Credit_LawFirm_Name" :value="item.Credit_LawFirm_ID"></el-option>
                                        </template>
                                    </el-select>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditControlLawFirm()">更改</el-button>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="保险费日期">
                                <div style="display: flex; align-items: center" v-if="result.TimeChange == 'true'">
                                    <el-date-picker v-model="result.Credit_Control_PremiumTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditProceedingTime(4)">保存</el-button>
                                </div>
                                <span v-else>{{ result.Credit_Control_PremiumTime }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="保全费日期">
                                <div style="display: flex; align-items: center" v-if="result.TimeChange == 'true'">
                                    <el-date-picker v-model="result.Credit_Control_MaintenamceCostsTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditProceedingTime(5)">保存</el-button>
                                </div>
                                <span v-else>{{ result.Credit_Control_MaintenamceCostsTime }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="立案缴费日期">
                                <div style="display: flex; align-items: center" v-if="result.TimeChange == 'true'">
                                    <el-date-picker v-model="result.Credit_Control_RegisterFeeTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditProceedingTime(6)">保存</el-button>
                                </div>
                                <span v-else>{{ result.Credit_Control_RegisterFeeTime }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="一审胜诉日期">
                                <div style="display: flex; align-items: center" v-if="result.TimeChange == 'true'">
                                    <el-date-picker v-model="result.Credit_Control_FirstInstance" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditProceedingTime(1)">保存</el-button>
                                </div>
                                <span v-else>{{ result.Credit_Control_FirstInstance }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="二审胜诉日期">
                                <div style="display: flex; align-items: center" v-if="result.TimeChange == 'true'">
                                    <el-date-picker v-model="result.Credit_Control_SecondInstance" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditProceedingTime(2)">保存</el-button>
                                </div>
                                <span v-else>{{ result.Credit_Control_SecondInstance }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="向法院申请执行日期">
                                <div style="display: flex; align-items: center" v-if="result.TimeChange == 'true'">
                                    <el-date-picker v-model="result.Credit_Control_ExecutionTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditProceedingTime(3)">保存</el-button>
                                </div>
                                <span v-else>{{ result.Credit_Control_ExecutionTime }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="快递公司">{{ result.Credit_Control_DeliveryName }}</el-descriptions-item>
                            <el-descriptions-item label="快递单号">{{ result.Credit_Control_DeliveryCode }}</el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                    <el-collapse-item title="订单及承诺还款信息" name="2">
                        <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="订单信息">
                                <el-table :data="result.orders" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Credit_Control_Orders_SN" label="订单号" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_Control_Orders_EngineeringName" label="工程名称" show-overflow-tooltip align="center"></el-table-column>
                                    <el-table-column prop="Credit_Control_Orders_MemberName" label="合同签订人" show-overflow-tooltip align="center"></el-table-column>
                                    <el-table-column prop="Credit_Control_Orders_RegionCode" label="分支机构" show-overflow-tooltip align="center"></el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="承诺还款信息">
                                <el-table :data="result.Repayment" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Time" label="承诺还款日期" align="center"></el-table-column>
                                    <el-table-column prop="ReturnMoney" label="承诺还款日期" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.ReturnMoney | thousandSeparator }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                    <el-collapse-item title="进展信息" name="3">
                        <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="项目金额">
                                <div class="rows">{{ result.Credit_Control_ProjectMoney | thousandSeparator }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="已完成金额">
                                <div class="rows">{{ result.Credit_Control_ReturnMoney | thousandSeparator }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="未完成金额">{{ result.Credit_Control_UnfinishedMoney | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="按期付款额">{{ result.Credit_Control_OnTimeReturnMoney | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="逾期付款额">{{ result.Credit_Control_OverdueReturnMoney | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="按期完成率">{{ result.OnTimeReturnMoneyRate }}</el-descriptions-item>
                            <el-descriptions-item label="逾期完成率">{{ result.OverdueReturnMoneyRate }}</el-descriptions-item>
                            <el-descriptions-item label="总完成率">{{ result.ProjectMoneyRate }}</el-descriptions-item>
                            <el-descriptions-item label="平均逾期付款天数">{{ result.AvgDay }}</el-descriptions-item>
                            <el-descriptions-item label="项目逾期未付额">{{ result.OverdueMoney | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="平均逾期未付天数">{{ result.AverageOverdueDays }}</el-descriptions-item>
                            <el-descriptions-item label="最长逾期付款额">{{ result.MaxOverdueMoney | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="最长逾期付款天数">{{ result.MaxOverdueMoneyDay }}</el-descriptions-item>
                            <el-descriptions-item label="三十日内将到期承诺额">{{ result.Credit_Control_CommitmentAmount }}</el-descriptions-item>
                            <el-descriptions-item label="诉讼时效剩余天数">{{ result.Credit_Control_LitigationDay }}</el-descriptions-item>
                            <el-descriptions-item label="项目进展" v-if="result.ProgressState == 'true'">
                                <div style="display: flex; align-items: center">
                                    <el-input v-model="remarks" placeholder="" clearable class="el-select-medium"></el-input>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditControlProgress()">保存</el-button>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                    <el-collapse-item title="进展明细及附件" name="4">
                        <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="回款明细">
                                <el-table :data="result.ReturnMoney" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Credit_Control_ReturnMoney_UserName" label="付款人" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_Control_ReturnMoney" label="到账金额" show-overflow-tooltip align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Credit_Control_ReturnMoney | thousandSeparator }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Credit_Control_ReturnMoney_Time" label="到账日期" show-overflow-tooltip align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Credit_Control_ReturnMoney_Time | formatDate }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Credit_Control_UseMoney" label="分款金额" show-overflow-tooltip align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Credit_Control_UseMoney | thousandSeparator }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Credit_Control_Distribute_Time" label="分款日期" show-overflow-tooltip align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Credit_Control_Distribute_Time | formatDate }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="逾期回款信息">
                                <el-table :data="result.OverdueReturnMoney" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Credit_Control_OverdueReturnMoney" label="逾期金额" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Credit_Control_OverdueReturnMoney | thousandSeparator }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Credit_Control_OverdueReturnMoneyDay" label="逾期天数" align="center"></el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目进展">
                                <el-table :data="ControlProgressLog" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" align="center" width="120"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center"></el-table-column>
                                    <el-table-column prop="Remarks" label="备注" align="center" show-overflow-tooltip></el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="状态变更">
                                <el-table :data="ControlStateLog" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" align="center" width="120"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center"></el-table-column>
                                    <el-table-column prop="Remarks" label="备注" align="center" show-overflow-tooltip></el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="附件列表">
                                <el-table :data="file" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" width="120" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Addtime | formatDate }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Type" label="类型" align="center"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="AttachmentName" show-overflow-tooltip label="附件名称" align="center"></el-table-column>
                                    <el-table-column prop="Remarks" label="附件" align="center">
                                        <template slot-scope="scope">
                                            <div class="operation-bar" v-if="scope.row.Remarks && scope.row.Remarks != '--'">
                                                <span class="operation-bar-block" @click="downFile(scope.row.Remarks)">打开</span>
                                            </div>
                                            <span v-else>{{ scope.row.Remarks }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--                                     
                                    <el-table-column prop="operation" label="操作" align="center">
                                        <template slot-scope="scope">
                                            <div class="operation-bar" v-if="scope.row.operation == '删除'">
                                                <span class="operation-bar-block operation-bar-block-del" @click="getDelCreditControlFile(scope.row)">删除</span>
                                            </div>
                                            <span v-else>{{ scope.row.operation }}</span>
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="附件上传" v-if="result.UploadState == 'true'">
                                <Hwupload ref="Hwupload" v-if="isControlDetail"></Hwupload>
                                <div>
                                    <el-input v-model="fileName" placeholder="请输入附件名称" clearable class="el-select-medium" style="margin: 10px 10px 0px 0px"></el-input>
                                    <el-button slot="trigger" type="primary" @click="getUpdateCreditControlFile()">保存附件</el-button>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>
</template>
<script>
import Hwupload from '@/components/Hwupload/index.vue';
export default {
    name: 'creditControlDetails',
    components: {
        Hwupload
    },

    mounted() {
        const id = this.$route.query.id;
        if (id) {
            this.id = id;
            this.activeNames = ['1'];
            this.getCreditControlByID();
            this.getOfficeMemberSelectOption();
        }
    },
    data() {
        return {
            loading: false,
            fileName: '', //附件名称
            remarks: '', //项目进展
            filePath: '', //附件路径
            result: {
                Credit_Control_AddTime: '',
                Credit_Control_Type: '',
                Credit_Control_State: '',
                Credit_Control_OfficeID: '',
                Credit_Control_AgentID: '',
                Credit_Control_Enclosure: '',
                Credit_Control_AddUserName: '',
                Credit_Control_Court: '',
                Credit_Control_LetterTime: '',
                Credit_Control_DeliveryName: '',
                Credit_Control_DeliveryCode: '',
                Credit_Control_OnTimeReturnMoney: '',
                Credit_Control_OverdueReturnMoney: '',
                AvgDay: '',
                MaxOverdueMoney: '',
                MaxOverdueMoneyDay: '',
                OnTimeReturnMoneyRate: '',
                OverdueReturnMoneyRate: '',
                ProjectMoneyRate: '',
                ProgressState: '',
                UploadState: '',
                StateChange: '',
                AgentChange: '',
                SelectState: [],
                SelectStateIndex: 1,
                orders: [],
                Repayment: [],
                ReturnMoney: [],
                OverdueReturnMoney: null,
                Credit_Control_ID: 10,
                Credit_Control_TypeName: '',
                Credit_Control_StateName: '',
                Credit_Control_OfficeName: '',
                Credit_Control_LargeRegionName: '',
                Credit_Control_AgentName: '',
                Credit_Control_CustomerName: '',
                Credit_Control_ApplicationTime: '',
                RepaymentTime: null,
                Credit_Control_ProjectMoney: '',
                CommitmentMoney: null,
                Credit_Control_ReturnMoney: '',
                Credit_Control_UnfinishedMoney: '',
                OverdueMoney: '',
                AverageOverdueDays: '',
                Credit_Control_CommitmentAmount: '',
                Credit_Control_LitigationDay: '',
                Credit_Control_FirstInstance: null,
                Credit_Control_SecondInstance: null,
                Credit_Control_ExecutionTime: null,
                IsProceeding: null,
                ChangeProceeding: false
            },
            file: [],
            activeNames: ['1'],
            Control_Agentopt: [],
            ControlProgressLog: [],
            ControlStateLog: [],
            isControlDetail: true,
            id: ''
        };
    },
    methods: {
        /*
    返回信控列表
    */
        handleisControlClose() {
            this.$emit('handleisControlClose');
        },
        /*
    获取信控项目信息
    */
        getCreditControlByID() {
            this.loading = true;
            this.$newsApi
                .getCreditControlByID({ id: this.id })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        try {
                            let result = res.data.data;
                            result.Credit_Control_State = Number(result.Credit_Control_State);
                            result.Credit_Control_AgentID = Number(result.Credit_Control_AgentID);
                            this.result = result;
                            this.getCreditControlAttachmentsLog();
                            this.getCreditControlProgressLog();
                            this.getCreditControlStateLog();
                        } catch (err) {
                            this.$message.error(err);
                        }
                    }
                })
                .finally(() => (this.loading = false));
        },

        /*
    查询经办人
    */
        getOfficeMemberSelectOption() {
            this.$newsApi.getOfficeMemberSelectOption().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Control_Agentopt = res.data.data;
                }
            });
        },

        /*
     项目进展添加
    */
        getUpdateCreditControlProgress() {
            this.$newsApi.getUpdateCreditControlProgress({ remarks: this.remarks, ID: this.result.Credit_Control_ID }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.remarks = '';
                    this.getCreditControlProgressLog();
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                }
            });
        },

        /*
    经办人变更
    */
        getUpdateCreditControlAgent() {
            this.$newsApi
                .getUpdateCreditControlAgent({
                    id: this.result.Credit_Control_ID,
                    agent: this.result.Credit_Control_AgentID
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.getCreditControlByID();
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }
                });
        },
        /*
    承办律所
    */
        getUpdateCreditControlLawFirm() {
            this.$newsApi
                .getUpdateCreditControlLawFirm({
                    id: this.result.Credit_Control_ID,
                    PayTypeID: this.result.Credit_Control_LawFirmID
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.getCreditControlByID();
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }
                });
        },
        /*
      修改日期
    */
        getUpdateCreditProceedingTime(type) {
            this.$newsApi
                .getUpdateCreditProceedingTime({
                    id: this.result.Credit_Control_ID,
                    type
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.getCreditControlByID();
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }
                });
        },
        /*
    状态变更
    */
        getUpdateCreditControlState() {
            this.$newsApi
                .getUpdateCreditControlState({
                    id: this.result.Credit_Control_ID,
                    status: this.result.Credit_Control_State
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.getCreditControlByID();
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }
                });
        },
        /*
     获取附件列表
    */
        getCreditControlAttachmentsLog() {
            this.$newsApi
                .getCreditControlAttachmentsLog({
                    id: this.result.Credit_Control_ID
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.file = res.data.data;
                    }
                });
        },

        /*
    获取项目进展列表
 */
        getCreditControlProgressLog() {
            this.$newsApi
                .getCreditControlProgressLog({
                    id: this.result.Credit_Control_ID
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.ControlProgressLog = res.data.data;
                    }
                });
        },
        /*
   获取状态列表
   */
        getCreditControlStateLog() {
            this.ControlStateLog = [];
            this.$newsApi
                .getCreditControlStateLog({
                    id: this.result.Credit_Control_ID
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.ControlStateLog = res.data.data;
                    }
                });
        },
        /*
     信控项目详情附件上传
   */
        getUpdateCreditControlFile() {
            this.filePath = this.$refs.Hwupload.filePath;
            this.$newsApi.getUpdateCreditControlFile({ remarks: this.filePath, Project_Name: this.fileName, ID: this.result.Credit_Control_ID }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.filePath = '';
                    this.fileName = '';
                    this.$refs.Hwupload.handleRemove();
                    this.getCreditControlAttachmentsLog();
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                }
            });
        },
        /*
      信控项目详情附件删除
    */
        getDelCreditControlFile(items) {
            this.$confirm('删除后不可恢复，确定删除么?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$newsApi.getDelCreditControlFile({ log_id: items.LogID, ID: this.result.Credit_Control_ID }).then((res) => {
                        if (res.data.Resultcode == 0) {
                            this.getCreditControlAttachmentsLog();
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        downFile(par) {
            window.open(par);
        }
    }
};
</script>

<style scoped lang="scss">
/* #f5f7fa */

.rows {
    width: 389px;
}
.hw-content {
    padding: 0px 20px;
}
.content {
    background: #fff;
    padding: 20px 0;
}
</style>